module.exports = __webpack_public_path__ + "img/plant_2_mobile.1a8914af.webp";